/* eslint-disable perfectionist/sort-imports */
import React from 'react';
import { useScrollToTop } from '@/hooks/use-scroll-to-top';

import Router from '@/routes/sections';
import ThemeProvider from '@/theme';
import '../sass/app.scss';

// ----------------------------------------------------------------------

export default function LayoutApp() {
  useScrollToTop();

  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
}
